import { throttle } from "alpinejs/src/utils/throttle";

export default () => ({
    openAccordions: [],
    mobileSticky: null,
    mobileStickyHeight: null,
    accordionsWrapper: null,
    accordionWrapper: null,
    header: null,
    announcementBar: null,
    body: null,
    mainContainer: null,
    lastScroll: 0,
    init() {
        this.mobileSticky = document.querySelector('.mobile-sticky')
        this.accordionsWrapper = document.querySelector('.accordions-wrapper')
        this.header = document.querySelector('.header-group')
        this.announcementBar = document.querySelector('.announcement-bar')
        this.body = document.querySelector('html body')
        this.mainContainer = document.querySelector('#MainContent')

        window.addEventListener("scroll", throttle(this.onHeaderScroll.bind(this), 40));

        this.onHeaderScroll();

        const faqContainers = document.querySelectorAll('.faq-list-items');
        if (!faqContainers.length) {
            return;
        } else {
            faqContainers.forEach(container => {
                container.addEventListener('click', (event) => {
                    const faqItem = event.target.closest('.faq-item');
                    if (faqItem) {
                        container.querySelectorAll('.faq-item').forEach(item => {
                            item.classList.remove('active');
                        });
                        faqItem.classList.add('active');
                    }
                });
            });
        }

    },

    onHeaderScroll() {
        this.mobileStickyHeight = this.mobileSticky.offsetHeight
        if (window.pageYOffset <= 0){
            document.body.classList.remove('scroll-down-faq')
            return
        }

        if (window.pageYOffset > 0 && window.pageYOffset > this.lastScroll && !document.body.classList.contains('scroll-down-faq')){
            document.body.classList.add('scroll-down-faq')
        }else if (window.pageYOffset < this.lastScroll && document.body.classList.contains('scroll-down-faq')){
            document.body.classList.remove('scroll-down-faq')
        }
        this.lastScroll = window.pageYOffset

        const headerHeight = this.header ? this.header.offsetHeight : 0;
        const announcementBarHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;
        const headerGroupHeight = headerHeight + announcementBarHeight;

        if (!this.body.classList.contains('scroll-down-faq')){
            this.mobileSticky.style.top = `${headerGroupHeight}px`

        }else{
            this.mobileSticky.style.top = `${headerHeight}px`


        }
    },

    toggleAccordion(accordionNumber) {
        const index = this.openAccordions.indexOf(accordionNumber);

        if (index === -1) {
            this.openAccordions.push(accordionNumber);
        } else {
            this.openAccordions.splice(index, 1);
        }
    },
    scrollToSection(sectionId) {
        let section = document.getElementById(sectionId);
        if (section) {
            let offset = 100
            let mediaQuery = window.matchMedia('(max-width: 980px)');
            if (mediaQuery.matches) {
                offset = 150;
            }
            const bodyRect = document.body.getBoundingClientRect().top;
            const elementRect = section.getBoundingClientRect().top;
            const elementPosition = elementRect - bodyRect;
            const offsetPosition = elementPosition - offset;
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    }
})
